import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../Constants";
import axios from "axios";
import history from "../../history";
import { clearRestaurants } from "../listeRestaurants/listeRestaurantsSlice";

// État initial
export const initialState = {
  utilisateur: { id: "", nom: "", connecte: false, jti: "", alias: "", rest_id_affichage: "" },
  restaurant_choisi: "",
  errorMessage: null,
  hasErrors: false,
  loading: false,
};

// Action asynchrone pour changer de restaurant (si besoin)
export const changementRestaurant = createAsyncThunk(
  "connexion/changementRestaurant",
  async (restaurantValue, thunkAPI) => {
    thunkAPI.dispatch(setRestaurant(restaurantValue));
  }
);

const connexionSlice = createSlice({
  name: "connexion",
  initialState,
  reducers: {
    // Lors d'une connexion réussie, on sauvegarde l'objet utilisateur reçu, en s'assurant d'inclure id, alias et jti
    getConnexionSuccess: (state, { payload }) => {
      state.utilisateur = {
        ...state.utilisateur,
        ...payload,
        id: payload.id,               // Doit être présent dans la réponse
        alias: payload.alias || "",   // Si présent
        jti: payload.jti || "",       // On actualise le jti si fourni
        rest_id_affichage: payload.rest_id_affichage || "",
      };
      state.loading = false;
      state.hasErrors = false;
      state.errorMessage = null;
      state.restaurant_choisi = payload.rest_id_affichage || "";
    },
    getConnexionFailure: (state, { payload }) => {
      state.utilisateur = initialState.utilisateur;
      state.errorMessage = payload;
      state.loading = false;
      state.hasErrors = true;
      state.restaurant_choisi = "";
    },
    getDeconnexionSuccess: (state) => {
      state.utilisateur = initialState.utilisateur;
      state.loading = false;
      state.hasErrors = false;
      state.errorMessage = null;
      state.restaurant_choisi = "";
    },
    getDeconnexionFailure: (state, { payload }) => {
      state.utilisateur = initialState.utilisateur;
      state.loading = false;
      state.hasErrors = true;
      state.restaurant_choisi = "";
    },
    // Mise à jour lors du choix du restaurant
    setRestaurant: (state, { payload }) => {
      state.restaurant_choisi = payload;
      state.utilisateur.rest_id_affichage = payload;
    },
    clearError: (state) => {
      state.errorMessage = null;
      state.hasErrors = false;
    },
    // Met à jour l'objet utilisateur entier (ou certains champs)
    updateUtilisateur: (state, { payload }) => {
      state.utilisateur = {
        ...state.utilisateur,
        ...payload,
      };
      // Si rest_id_affichage est dans le payload, mettre à jour restaurant_choisi aussi
      if (payload.rest_id_affichage !== undefined) {
        state.restaurant_choisi = payload.rest_id_affichage;
      }
    },
  },
  extraReducers: {
    [changementRestaurant.fulfilled]: (state) => {
      console.log("changementRestaurant fulfilled");
    },
  },
});

export const {
  getConnexionSuccess,
  getConnexionFailure,
  getDeconnexionSuccess,
  getDeconnexionFailure,
  setRestaurant,
  clearError,
  updateUtilisateur,
} = connexionSlice.actions;

export const connexionSelector = (state) => state.connexion;
export default connexionSlice.reducer;

// Fonction de connexion par identifiant (formulaire 1)
export function fetchConnexion(rest, id, mdp) {
  return async (dispatch) => {
    const request_data = { rest_id: rest, id: id, mdp: mdp };
    const config = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    };
    try {
      const response = await axios.post(
        API_URL + "/compte/connexion/utilisateur",
        request_data,
        config
      );
      dispatch(getConnexionSuccess(response.data));
      dispatch(clearRestaurants());
      if (response.data.type !== "superadmin") {
        history.replace("/dashboard");
      } else {
        history.replace("/admin");
      }
    } catch (error) {
      dispatch(
        getConnexionFailure({
          status: error.response.status,
          message: error.response.data,
        })
      );
    }
  };
}

// Fonction de connexion par alias (formulaire 2)
export function fetchConnexionAlias(alias, mdp) {
  return async (dispatch) => {
    const request_data = { alias: alias, mdp: mdp };
    const config = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    };
    try {
      const response = await axios.post(
        API_URL + "/compte/connexion/alias",
        request_data,
        config
      );
      // Assurez-vous que la réponse contient bien "id", "alias" et "jti"
      dispatch(getConnexionSuccess(response.data));
      dispatch(clearRestaurants());
      if (response.data.type !== "superadmin") {
        if (
          response.data.restaurants_affichage_list &&
          response.data.restaurants_affichage_list.length === 1
        ) {
          const singleRestaurant = response.data.restaurants_affichage_list[0];
          // Ici, nous utilisons fetchConnexion pour recréer une connexion classique
          return dispatch(
            fetchConnexion(
              singleRestaurant.restaurants_affichage,
              response.data.nom,
              mdp
            )
          );
        } else {
          history.replace("/listeRestaurants");
        }
      } else {
        // Les superadmins vont aussi sur la liste des restaurants maintenant
        history.replace("/listeRestaurants");
      }
    } catch (error) {
      dispatch(
        getConnexionFailure({
          status: error.response.status,
          message: error.response.data,
        })
      );
    }
  };
}

// Fonction de déconnexion
export function fetchDeconnexion() {
  return async (dispatch, getState) => {
    const utilisateur = getState().connexion.utilisateur;
    const config = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    };
    await axios
      .patch(API_URL + "/compte/deconnexion/utilisateur", utilisateur, config)
      .then((res) => {
        dispatch(getDeconnexionSuccess());
        dispatch(clearRestaurants());
        history.push("/connexion/" + utilisateur.rest_id_affichage);
      })
      .catch((error) => {
        dispatch(getDeconnexionFailure());
      });
  };
}
